<script lang="ts">
	import CameraZonesSettings from 'src/components/Camera/DeviceDrawer/CameraZones/CameraZonesSettings.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content" class="flex-full-height justify-content-start">
		<CameraZonesSettings {device} />
	</div>
</DeviceViewStateWrapper>
